import { render, staticRenderFns } from "./PsiDetailRecurrencies.vue?vue&type=template&id=0894abea&scoped=true"
import script from "./PsiDetailRecurrencies.vue?vue&type=script&lang=js"
export * from "./PsiDetailRecurrencies.vue?vue&type=script&lang=js"
import style0 from "./PsiDetailRecurrencies.vue?vue&type=style&index=0&id=0894abea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894abea",
  null
  
)

export default component.exports